import { IconButton, Tooltip } from '@material-ui/core';
import HelpIcon from '@material-ui/icons/Help';

export const MapperInfoButton = ({title, onClick=undefined}) => (
	
	<Tooltip title={title} placement="top">
		<IconButton aria-label="Info" size="small"  onClick={onClick}>
			<HelpIcon />
		</IconButton>
	</Tooltip>
);
